import { useStateStore } from "@/context/stateStore";
import { ICycle } from "@/models/types/cycle";
import { apiRequest, hasBaseUrl, hasEmail } from "../helpers/apiClient";

export async function CreateGrowingPlant({ cycle, user, urlToUse }: { cycle: ICycle, user: string, urlToUse: string }) {

    if (!cycle) {
        return { status: false, message: "Plant name, image URL, and description are required" };
    }

    if (!hasEmail(user)) {
        return { status: false, message: "User email is required" };
    }

    if (!hasBaseUrl(urlToUse)) {
        return { status: false, message: "Base URL is not set" };
    }

    const result = await apiRequest<{ newCycle: ICycle }>({
        url: `${urlToUse}/api/cycle/create`,
        method: 'POST',
        body: { cycle, email: user },
        failureMessage: 'Error creating growing session',
    });

    if (!result.success || !result.data) {
        return { status: false, message: result.message };
    }

        const data = result.data;
        const newCycle = data.newCycle as ICycle;
        if (!newCycle) {
            return { status: false, message: "Invalid cycle data returned" };
        }
        const iCycles = useStateStore.getState().activelyGrowing;
        useStateStore.setState({
            activelyGrowing: [...iCycles, newCycle],
        });
        return { status: true, message: "Growing session created successfully" };
}
